//
// Copyright (c) 2025 Comcast
//

import { api } from './api'

const enhancedApi = api.enhanceEndpoints({
  addTagTypes: [
    'ticketProvider',
  ],
})

const extendedApi = enhancedApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchTicketProviders: builder.query({
      query: () => '/admin/ticket_providers',
      providesTags: (result) => [{ type: 'ticketProvider', id: 'LIST' }],
    }),

    createTicketProvider: builder.mutation({
      query: ({ params }) => {
        return ({
          url: '/admin/ticket_providers',
          method: 'POST',
          body: params,
        })
      },
      invalidatesTags: ['ticketProvider'],
    }),

    removeTicketProvider: builder.mutation({
      query: (ticketProviderId) => {
        return ({
          url: `/admin/ticket_providers/${ticketProviderId}`,
          method: 'DELETE',
        })
      },
      invalidatesTags: ['ticketProvider'],
    }),

    updateTicketProvider: builder.mutation({
      query: ({ ticketProviderId, params, justification }) => {
        return ({
          url: `/admin/ticket_providers/${ticketProviderId}`,
          method: 'PATCH',
          body: {
            ticket_provider: params,
            ...(!!justification && { audit_comment: justification }),
          },
        })
      },
      invalidatesTags: ['ticketProvider'],
    }),

    cleanupProviderTickets: builder.mutation({
      query: ({ ticketProviderId }) => {
        return ({
          url: `/admin/ticket_providers/${ticketProviderId}/cleanup_provider_tickets`,
          method: 'GET',
        })
      },
    }),
    importTicketProvider: builder.mutation({
      query: ({ ticketProviderConfig }) => {
        return ({
          url: '/admin/ticket_providers/import',
          method: 'POST',
          body: ticketProviderConfig,
        })
      },
      extraOptions: { isFileUpload: true },
      invalidatesTags: ['ticketProvider'],
    }),

  }),
  overrideExisting: false,
})

export const {
  useFetchTicketProvidersQuery,
  useCreateTicketProviderMutation,
  useRemoveTicketProviderMutation,
  useUpdateTicketProviderMutation,
  useCleanupProviderTicketsMutation,
  useImportTicketProviderMutation,
} = extendedApi
